import { render, staticRenderFns } from "./NavUserMenu.vue?vue&type=template&id=774c031c&scoped=true&"
import script from "./NavUserMenu.vue?vue&type=script&lang=js&"
export * from "./NavUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c031c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774c031c')) {
      api.createRecord('774c031c', component.options)
    } else {
      api.reload('774c031c', component.options)
    }
    module.hot.accept("./NavUserMenu.vue?vue&type=template&id=774c031c&scoped=true&", function () {
      api.rerender('774c031c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NavUserMenu.vue"
export default component.exports